export const getFlowSessionCookieName = (flowName: string) => `${flowName}-flowSessionId`
export const getConsultationRequestCookieName = (flowName: string) =>
  `${flowName}-consultationRequestId`

export const getTempFlowSessionCookieName = (flowName: string) =>
  `temp_${getFlowSessionCookieName(flowName)}`

export const AUTH_COOKIE_NAME = 'authToken'
